import { Autocomplete, Menu, MenuItem, TextField } from "@mui/material";
import { Delete, ContentCopy, Save, RefreshOutlined, Check, FileDownload } from "@mui/icons-material";

import { CustomAutocomplete } from "../../../helpers";

import type { JobsDashboardTableViewModel } from "../JobsDashboardTable.types";

export interface MobileMenuProps {
	vm: JobsDashboardTableViewModel;
}

export function MobileMenu({ vm }: MobileMenuProps) {
	const isDisabled = !vm.selectedView && !vm.searchParams.has("v");

	return (
		<Menu
			anchorEl={vm.mobileMenuElement}
			open={Boolean(vm.mobileMenuElement)}
			onClose={() => vm.setMobileMenuElement(null)}
		>
			{vm.companyOptions.length > 1 && (
				<CustomAutocomplete
					id="company-dropdown"
					optionLabelField="name"
					loading={false}
					options={vm.companyOptions}
					selectedOption={vm.selectedCompany}
					onChange={vm.onCompanyChanged}
					className="dashboard-dropdown show-on-mobile-screen"
					label="Company"
					placement="right"
					size="small"
				/>
			)}
			<Autocomplete
				id="view-dropdown"
				className="dashboard-dropdown show-on-mobile-screen"
				options={vm.views}
				value={vm.selectedView}
				groupBy={(option) => (option.group === "Default" ? "System Views" : option.group.toString())}
				getOptionKey={(option) => option.id}
				getOptionLabel={(option) => option.name}
				onChange={vm.onSavedViewChanged}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Saved View"
						placeholder="Select a view to load jobs"
						variant="outlined"
						size="small"
					/>
				)}
			/>
			<MenuItem onClick={vm.refreshJobs} className="show-on-small-screen" disabled={isDisabled}>
				<RefreshOutlined />
				<div className="right-menu-text">Refresh Jobs</div>
			</MenuItem>
			<MenuItem onClick={vm.saveCurrentView} className="show-on-small-screen" disabled={isDisabled}>
				<Save />
				<div className="right-menu-text">Save Current View</div>
			</MenuItem>
			<MenuItem onClick={vm.copyLinkToClipboard} className="show-on-small-screen" disabled={vm.copyLinkDisabled}>
				<ContentCopy />
				<div className="right-menu-text">Copy Link to Clipboard</div>
			</MenuItem>
			<MenuItem onClick={vm.deleteView} className="show-on-small-screen" disabled={!vm.selectedView}>
				<Delete />
				<div className="right-menu-text">Delete View</div>
			</MenuItem>
			<MenuItem
				onClick={() => {
					vm.setMarkJobsReadyVisible(true);
				}}
				className="show-on-small-screen"
				disabled={isDisabled}
			>
				<Check />
				<div className="right-menu-text">Mark Jobs Ready</div>
			</MenuItem>
			<MenuItem onClick={vm.exportCSV} disabled={isDisabled}>
				<FileDownload />
				<div className="right-menu-text">Export as CSV</div>
			</MenuItem>
		</Menu>
	);
}
